import React, {MutableRefObject} from 'react';
import * as Yup from 'yup';
import {Form as FormikForm, Formik} from 'formik';
import {FormikHelpers, FormikProps, FormikValues} from 'formik/dist/types';
import {IComponentWithChildren} from 'models';
interface IFormProps<T> extends IComponentWithChildren {
  initialValues: T;
  validationSchema: Yup.ObjectSchema;
  submitHandler: (values: T, actions: FormikHelpers<T>) => void;
  validateOnMount?: boolean;
  validateOnChange?: boolean;
  validateOnBlur?: boolean;
  formikRef?: MutableRefObject<FormikProps<FormikValues>>;
}

export function Form<T>({
  initialValues,
  validationSchema,
  submitHandler,
  children,
  validateOnMount = false,
  validateOnChange = true,
  validateOnBlur = false,
  formikRef,
}: IFormProps<T>) {
  return (
    <Formik
      enableReinitialize
      innerRef={formikRef}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={submitHandler}
      validateOnChange={validateOnChange}
      validateOnMount={validateOnMount}
      validateOnBlur={validateOnBlur}
    >
      <FormikForm style={{width: '100%'}}>{children}</FormikForm>
    </Formik>
  );
}
